import React from 'react';
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import {Controller} from "react-hook-form";
import WarningFormControl from "./WarningFormControl";
import {wrapOnFieldChanged} from "../../store/utils/wrapper";
import {getArtistTatorte} from "../../models/artist";
import {renderOptionGroup, renderRecentOptionGroup} from "./ArtistOptionGroup";


const ArtistSelection = ({
                             control,
                             sx,
                             controllerName,
                             fullWidth,
                             artistsMap,
                             tatortMap,
                             studioTatOrtID,
                             selectedArtistID,
                             onChange,
                             disabled,
                             error,
                             isWarning,
                             helperText,
                             label,
                             showRecents,
                             recentArtistIds,
                             recentGroupLabel
                         }) => {


    if (!artistsMap || !tatortMap || !onChange && !control) {
        return null
    }

    if (!control) {
        return (
            <React.Fragment>
                <Select
                    readOnly={disabled}
                    fullWidth={fullWidth}
                    value={selectedArtistID && artistsMap[selectedArtistID] ? selectedArtistID : ''}
                    sx={sx}
                    onChange={e => onChange(e.target.value)}
                    variant="outlined"
                    data-testid="artist-selection"
                    inputProps={{
                        name: 'artist',
                        id: 'artist-native',
                    }}
                >
                    {showRecents && recentArtistIds && recentGroupLabel ? renderRecentOptionGroup({
                        artistsMap,
                        recentArtistIds,
                        label: recentGroupLabel,
                        key: 'artist-recent'
                    }) : null}
                    {getArtistTatorte(artistsMap, tatortMap, studioTatOrtID).map(id => renderOptionGroup({
                        artistsMap,
                        tatortMap,
                        tatortID: id,
                        ausgeschiedene: false,
                        key: id,
                    }))}
                    {renderOptionGroup({
                        artistsMap,
                        tatortMap,
                        tatortID: 0,
                        ausgeschiedene: true,
                        key: 'artist-ausgeschiedene',
                    })}
                </Select>
            </React.Fragment>
        )
    }

    return (

        <React.Fragment>
            <Controller name={controllerName}
                        control={control}
                        error={error}
                        defaultValue=''
                        render={({field}) =>
                            <WarningFormControl variant="standard" fullWidth={fullWidth} error={error}
                                                isWarning={isWarning} sx={sx}>
                                <InputLabel id="artist-label">{label || 'Artist'}</InputLabel>
                                <Select {...field}
                                        onChange={wrapOnFieldChanged(field.onChange, onChange)}
                                        labelId="artist-label"
                                        readOnly={disabled}
                                        data-testid="artist-selection"
                                >
                                    {showRecents && recentArtistIds && recentGroupLabel ? renderRecentOptionGroup({
                                        artistsMap,
                                        recentArtistIds,
                                        label: recentGroupLabel,
                                        key: 'artist-recent'
                                    }) : null}
                                    {getArtistTatorte(artistsMap, tatortMap).map(id => renderOptionGroup({
                                        tatortMap,
                                        artistsMap,
                                        tatortID: id,
                                        ausgeschiedene: false,
                                        key: id,
                                    }))}
                                    {renderOptionGroup({
                                        tatortMap,
                                        artistsMap,
                                        tatortID: 0,
                                        ausgeschiedene: true,
                                        key: 'artist-ausgeschiedene',
                                    })}
                                </Select>
                                {helperText && <FormHelperText>{helperText}</FormHelperText>}
                            </WarningFormControl>
                        }
            />
        </React.Fragment>
    )

}

export default ArtistSelection